import { jwtDecode } from 'jwt-decode';

import service from 'service/auth';

import { Token } from 'commons/modules/auth/token';

import { INVESTMENT_OFFICES, KEYCLOAK_ROLES } from 'constants/globals';

import { arrayValidation } from 'utils/array';

import { getRole } from './roles';
import { getInvestmentOfficeId } from './office';

const getUserRole = (token: string) => {
  const data: Token = jwtDecode(String(token));
  let role = '';
  const authorities = data?.realm_access?.roles || [];
  if (arrayValidation(authorities)) {
    role = getRole(authorities);
  }
  return role;
};

export const accessDeniedByClientSmartCapital = (defaultValue = false) => {
  if (getInvestmentOfficeId() !== INVESTMENT_OFFICES.SMART_CAPITAL)
    return defaultValue;

  const token = service.getToken();

  if (!token) return false;

  const role = getUserRole(token);

  if (String(role).toUpperCase() !== KEYCLOAK_ROLES.banquero) return false;

  return true;
};

export const accessDeniedClientSmartCapitalByRole = (
  rol = KEYCLOAK_ROLES.banquero,
) => {
  if (getInvestmentOfficeId() !== INVESTMENT_OFFICES.SMART_CAPITAL)
    return false;

  const token = service.getToken();

  if (!token) return false;

  const role = getUserRole(token);

  return String(role).toUpperCase() === String(rol).toUpperCase();
};
